var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConclusion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.88281 4.00781H3.00781C2.62242 4.00781 2.25281 4.16091 1.9803 4.43342C1.70778 4.70594 1.55469 5.07554 1.55469 5.46094V21.4453C1.55469 21.8307 1.70778 22.2003 1.9803 22.4728C2.25281 22.7453 2.62242 22.8984 3.00781 22.8984H18.9922C19.3776 22.8984 19.7472 22.7453 20.0197 22.4728C20.2922 22.2003 20.4453 21.8307 20.4453 21.4453V5.46094C20.4453 5.27011 20.4077 5.08115 20.3347 4.90485C20.2617 4.72855 20.1546 4.56836 20.0197 4.43342C19.8848 4.29849 19.7246 4.19145 19.5483 4.11843C19.372 4.0454 19.183 4.00781 18.9922 4.00781H15.1172",
    stroke: "#717780",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.7983 4.96688C14.7496 5.11079 14.6572 5.23586 14.5338 5.32448C14.4104 5.4131 14.2624 5.46082 14.1104 5.46094H7.89107C7.73917 5.46082 7.59112 5.4131 7.46774 5.32448C7.34436 5.23586 7.25187 5.11079 7.20326 4.96688L6.23451 2.06062C6.19698 1.95105 6.18619 1.83409 6.20304 1.7195C6.2199 1.60491 6.2639 1.49601 6.33138 1.40188C6.40007 1.30966 6.48915 1.23457 6.59166 1.18247C6.69417 1.13038 6.80734 1.10269 6.92232 1.10156H15.0792C15.1942 1.10269 15.3073 1.13038 15.4099 1.18247C15.5124 1.23457 15.6014 1.30966 15.6701 1.40188C15.7376 1.49601 15.7816 1.60491 15.7985 1.7195C15.8153 1.83409 15.8045 1.95105 15.767 2.06062L14.7983 4.96688Z",
    stroke: "#717780",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.5391 6.91406V16.4853C17.5387 16.8706 17.3854 17.2399 17.1128 17.5122L15.0591 19.5659C14.7868 19.8385 14.4175 19.9918 14.0322 19.9922H5.1875C4.99558 19.9897 4.81223 19.9123 4.67652 19.7766C4.5408 19.6409 4.46345 19.4575 4.46094 19.2656V6.91406",
    stroke: "#717780",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.6953 19.9922V16.6016C12.6953 16.2162 12.8484 15.8466 13.1209 15.574C13.3934 15.3015 13.763 15.1484 14.1484 15.1484H17.5391",
    stroke: "#717780",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConclusion);
export default __webpack_public_path__ + "static/media/conclusion.dc3c68e16212358d507a65fae29ff936.svg";
export { ForwardRef as ReactComponent };